import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = {
  key: 1,
  class: "text"
}

import TButton from "vue-tailwind/dist/t-button";
import { computed, useSlots } from "vue";
import { TranslateResult } from "vue-i18n";
import { isExistSlot } from "@/plugins/helpers";

export interface Props {
  text?: string | TranslateResult;
  variant?: string;
  size?: string;
  outline?: boolean;
  disabled?: boolean;
  wide?: boolean;
  type?: string;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'VButton',
  props: {
    text: { default: "" },
    variant: { default: "primary" },
    size: { default: "md" },
    outline: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
    wide: { type: Boolean, default: false },
    type: { default: "button" }
  },
  emits: ["click"],
  setup(__props: any, { emit: __emit }) {

const emit = __emit;
const slots = useSlots();

const props = __props;

const buttonClasses = computed(() => {
  const variant = `button-${props.variant}`;
  const size = `button-size-${props.size}`;

  const classes = {
    "button-wide": props.wide,
    "icon-left-padding": isExistSlot("icon-left", slots),
  };

  return [variant, size, classes];
});

const onClick = () => {
  emit("click");
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(TButton), {
    class: _normalizeClass(["button", buttonClasses.value]),
    disabled: _ctx.disabled,
    variant: _ctx.variant,
    type: _ctx.type,
    onClick: onClick
  }, {
    default: _withCtx(() => [
      (_unref(isExistSlot)('icon-left', _unref(slots)))
        ? (_openBlock(), _createElementBlock("span", _hoisted_1, [
            _renderSlot(_ctx.$slots, "icon-left")
          ]))
        : _createCommentVNode("", true),
      (_ctx.text.length)
        ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(_ctx.text), 1))
        : _createCommentVNode("", true)
    ], undefined, true),
    _: 3
  }, 8, ["class", "disabled", "variant", "type"]))
}
}

})